(function ($) {
    $.nette.ext('reportAgent', {
        init() {
            const self = this;

            this.ext('snippets', true).after($.proxy(($el) => {
                self.initReportAgent($el);
            }, this));

            self.initReportAgent($('body'));
        },
    }, {
        initReportAgent($el) {
            const $form = $el.find('.report-agent-form');
            const $buttonCancel = $form.find('.js-button__cancel');

            $buttonCancel.on('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                $buttonCancel.closest('.modal').modal('hide');
            });
        },
    });
}(jQuery));
